import { UseMutateAsyncFunction, useMutation } from 'react-query';

import {
  LogEntriesConstantsEnums,
  LogEntryPriorityEnum,
  LogEntryTypesEnums
} from '@nw/shared/config';
import {
  captureLogEntriesExceptionWithScope,
  getHmacSha256Signature
} from '@nw/shared/utils';

import { DialCodes } from '../../../constants/CountryDialCodeConstant';
import {
  LoginWithPhoneOTPRequestType,
  LoginWithPhoneOTPResponseType
} from '../../../services/IbUserAccountsServices/APIService/types';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

function useGetLoginWithPhoneOTP(): {
  userLoginWithPhoneNumberAPI: UseMutateAsyncFunction<
    LoginWithPhoneOTPResponseType,
    unknown,
    {
      phoneNumber: string;
      clientId?: string;
    },
    unknown
  >;
  error;
  status;
} {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const getLoginWithPhoneOTP = async (params) => {
    const { phoneNumber, clientId } = params;
    const countryCode = DialCodes.india;
    const msg = `{"phone_number": "${phoneNumber}", "country_code": "${countryCode}"}`;
    const hmacSignature = await getHmacSha256Signature(msg);

    captureLogEntriesExceptionWithScope(
      LogEntriesConstantsEnums.GET_LOGIN_OTP_API_INITIATED,
      {
        path: window.location.href
      },
      LogEntryTypesEnums.INFORMATION,
      LogEntryPriorityEnum.HIGH
    );

    const requestObject: LoginWithPhoneOTPRequestType = {
      phone_number: phoneNumber,
      country_code: countryCode,
      signature: hmacSignature
    };

    if (clientId) {
      requestObject.client_id = clientId;
    }
    return ibUserAccountsAPIService.userLoginWithPhoneNumber(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(getLoginWithPhoneOTP, {
    mutationKey: ['userLoginWithPhoneNumberAPI']
  });

  return {
    userLoginWithPhoneNumberAPI: mutateAsync,
    error,
    status
  };
}

export { useGetLoginWithPhoneOTP };
